import { inject } from '@angular/core';
import { InvitationsService } from '@invitations/infra';
import { map, Observable, switchMap } from 'rxjs';
import { ActivatedRoute, Params } from '@angular/router';
import {
  GameInvitationCandidate,
  GetGameInvitationCandidatesPathParams,
  GetGameInvitationCandidatesResponse
} from '@core-http';
import { InvitationCandidate, InvitationsListQueryResult } from './get-invitations-list.query-result';

export class GetInvitationsListForHostQueryHandler {
  private readonly invitationsService: InvitationsService = inject(InvitationsService);
  private readonly activatedRoute: ActivatedRoute = inject(ActivatedRoute);

  getList(): Observable<InvitationsListQueryResult> {
    return this.activatedRoute.params.pipe(
      switchMap((params: Params) => {
        const pathParams: GetGameInvitationCandidatesPathParams = { hostedGameId: params['id'] };
        return this.invitationsService.getList(pathParams);
      }),
      map((response: GetGameInvitationCandidatesResponse) => this.mapToQueryResult(response))
    );
  }

  private mapToQueryResult(response: GetGameInvitationCandidatesResponse): InvitationsListQueryResult {
    return {
      availableToInvite: this.mapCandidates(response.availableToInvite),
      invited: this.mapCandidates(response.invited),
      hidden: this.mapCandidates(response.hidden)
    };
  }

  private mapCandidates(candidates: GameInvitationCandidate[]): InvitationCandidate[] {
    return candidates.map((candidate: GameInvitationCandidate) => ({
      userId: candidate.userId,
      displayName: candidate.displayName,
      thumbnail: candidate.thumbnail ?? '',
      gamesPlayed: candidate.gamesPlayed,
      isInvited: candidate.isInvited,
      isFavorite: candidate.isFavorite,
      isHidden: candidate.isHidden
    }));
  }
}
